import {Panel} from "@/app-autocomplete/components/Panel.tsx";
import {Product} from "@/app-autocomplete/components/Product.tsx";
import {useCollection} from "@/app-autocomplete/hooks/useCollection.ts";
import {useCustomizedUrl} from "@/hooks/useCustomizedUrl.ts";
import {useEnrichedProducts} from "@/hooks/useEnrichedProducts.ts";
import {useTranslations} from "@/hooks/useTranslations.ts";
import {useAlgoliaShopConfig} from "@/providers/AlgoliaShopConfigProvider.tsx";
import {useAutocomplete} from "../providers/AutocompleteProvider.tsx";


export function Products() {
    const {
        autocompleteState: {query, status, context: {nbProducts}},
        autocomplete,
    } = useAutocomplete();
    const customizedUrl = useCustomizedUrl();
    const tc = useTranslations();
    const {items, source} = useCollection("productsPlugin");
    const enrichedItems = useEnrichedProducts(items);
    if (!query || !source) return;
    if (!enrichedItems || enrichedItems.length === 0 && status !== "loading") return <NoEntries/>;
    return (
        <Panel title={tc.products}>
            <ol className="aa-Source aa-products" {...autocomplete.getListProps({source})}>
                {enrichedItems.map((item) => (
                    <Product key={item.objectID} hit={item} postFixLink={encodeURIComponent(query)} />
                ))}
            </ol>
            {
                (nbProducts as number > 0 || query) &&
                <div className={"aa-showAllButton"}>
                    <a href={`/${customizedUrl}/search/?input_search=${encodeURIComponent(query)}`}
                       className="button button--primary">
                        {tc.all} {nbProducts as number} {tc.showHits}
                    </a>
                </div>
            }
        </Panel>
    );
}

function NoEntries() {
    const {
        autocompleteState: {query},
    } = useAutocomplete();
    const {tc} = useAlgoliaShopConfig();
    return (
        <div className="emptybox">
            {tc.noEntriesFoundForSearch} <q>{query}</q>.
        </div>
    );
}
